import React, {FC, useCallback} from "react";
import {Card} from "react-bootstrap";
import {Field} from "formik";
import {FormikAsyncSelect, FormikRowInput, FormikRowCheckbox} from "@components/panel/formik";
import ConsumerDailyService from "@api/consumer/consumerDailyService";

interface BaseBlockProps {
    editForm?: boolean;
}

const BaseInfoBlock: FC<BaseBlockProps> = ({editForm}) => {

    const searchGroups = useCallback((text: string) => {
        const api = new ConsumerDailyService();

        return api.searchGiftGroup({
            name: text
        }).then(res => {
            if (res.success) {
                return res.data.map(group => ({
                    value: group.id,
                    label: group.name
                }))
            }
            return [];
        });
    }, []);

    return (
        <Card className="mb-3">
            <Card.Header as="h6" className="bg-body-tertiary">
                Основное
            </Card.Header>
            <Card.Body>
                <Field
                    label='Название'
                    type='text'
                    name='name'
                    placeholder='Название подарка'
                    component={FormikRowInput} />
                <Field
                    label='День'
                    name='days'
                    type='number'
                    min={1}
                    max={1000}
                    placeholder='1-1000'
                    description='День, на который будет выдан бонус'
                    component={FormikRowInput} />
                <Field
                    label='Единоразово'
                    id='daily-onetime'
                    name='oneTime'
                    type='switch'
                    description='Подарок может быть выдан только один раз, даже при сбросе счетчика'
                    component={FormikRowCheckbox} />
                <Field
                    label='Повторяем'
                    id='daily-repeat'
                    name='repeat'
                    type='switch'
                    description='Если включено - бонус будет выдаваться ежедневно'
                    component={FormikRowCheckbox} />
                <Field
                    label="Группа"
                    name="groupId"
                    loadOptions={searchGroups}
                    row
                    component={FormikAsyncSelect}
                />
                {editForm && (
                    <Field
                        label='Активно'
                        id='daily-active'
                        name='isActive'
                        type='switch'
                        component={FormikRowCheckbox} />
                )}
            </Card.Body>
        </Card>
    )
}

export default BaseInfoBlock;
